import $ from "jquery";

function init() {
    const toggle = $("[data-toggle]");

    if (toggle.length) {
        toggle.on("click", function (e) {
            e.preventDefault();
            const target = $(this).data("target") || $(this).attr("href");
            $(target).toggleClass("d-none");
        });
    }
}

export default init();
